import { SEASONAL_ILLUSTRATIONS } from "./constants";
import { type SeasonalIllustrationKey } from "./types";

import { easter } from "date-easter";
import {
  addDays,
  endOfDay,
  isWithinInterval,
  startOfDay,
  subDays,
} from "date-fns";

export const isSeasonalIllustrationKey = (
  possibleIllustrationKey: string | SeasonalIllustrationKey,
): possibleIllustrationKey is SeasonalIllustrationKey =>
  possibleIllustrationKey in SEASONAL_ILLUSTRATIONS;

const getEasterSunday = (year: number): Date => {
  const { month, day } = easter(year);
  return new Date(year, month - 1, day);
};

export const getSeasonalIllustrationKey =
  (): SeasonalIllustrationKey | null => {
    const date = new Date();
    const year = date.getFullYear();
    const month = date.getMonth(); // 0-indexed
    const day = date.getDate();

    const easter = getEasterSunday(year);
    // Palm Sunday (-7) through Easter Monday (+1)
    const easterStart = startOfDay(subDays(easter, 7));
    const easterEnd = endOfDay(addDays(easter, 1));
    if (isWithinInterval(date, { start: easterStart, end: easterEnd })) {
      return "easter";
    }

    // 17. mai
    if (month === 4 && day === 17) {
      return "nationalDayNO";
    }

    // Fredag den 13.
    if (day === 13 && date.getDay() === 5) {
      return "friday13th";
    }

    // Juni - Pride
    if (month === 5) {
      return "pride";
    }

    // 31. oktober - Halloween
    if (month === 9 && day === 31) {
      return "halloween";
    }

    // Desember - jul
    if (month === 11) {
      return "christmas";
    }

    return null;
  };
